import { render, staticRenderFns } from "./BadgeModal.vue?vue&type=template&id=e8549280&scoped=true"
import script from "./BadgeModal.vue?vue&type=script&lang=js"
export * from "./BadgeModal.vue?vue&type=script&lang=js"
import style0 from "./BadgeModal.vue?vue&type=style&index=0&id=e8549280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8549280",
  null
  
)

export default component.exports